
// function applyScript() {
//     var boldOptionTitles = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value_title');

//     boldOptionTitles.forEach(function (titleElement) {
//         var titleText = titleElement.textContent.trim();

//       if(titleText.includes('Font Futura PT Light')){
//         titleElement.classList.add('futuramediumbt');
//       }
//       if(titleText.includes('Font Bangers')){
//          titleElement.classList.add('BangersRegular');
//       }
//       if(titleText.includes('Font Courgette')){
//          titleElement.classList.add('Courgette');
//       }
//         if(titleText.includes('Font Alex Brush')){
//          titleElement.classList.add('AlexBrushRegular');
//       }
//          if(titleText.includes('Font Amatic SC')){
//          titleElement.classList.add('AmaticSC-Regular');
//       }
//            if(titleText.includes('Font Smooch')){
//          titleElement.classList.add('Smooch');
//       }
      
      
       
//     });
//   var inputElement = document.querySelector('.bold_option_textbox input').classList.value;
 
//    // Add event listener for radio input changes
//     document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value input[type="checkbox"]').forEach(function (radio) {
//         radio.addEventListener('change', function () {
//           var newClass = this.closest('.bold_option_value').querySelector('.bold_option_value_title').classList.value;
//           // Set the class of the input element
//           // document.querySelector('.bold_option_textbox input').className =  inputElement +' '+ newClass;
//            document.querySelector('#displayTextBold').className = newClass;
//         });
//     });
    

// }

// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function(){
//     document.querySelectorAll('.bold_option.bold_option_checkbox .bold_option_element input[type="checkbox"]').forEach(function (checkbox) {
//       checkbox.addEventListener('change', function () {
//          var titleChecked = this.closest('.bold_option_checkbox').querySelector('.bold_option_title').textContent.trim();
//          if(titleChecked.includes('add custom engraving')){
//         console.log("RADIO CHANGE", titleChecked);
           
//           applyScript();
//          } else {
//         console.log("RADIO CHANGE elseeee", titleChecked);
           
//          }
//       })
//     })
      
    
//   },200)
// });
$(document).ready(function() {
    console.log("Bold Custom JS Init");

    // 1. Update text in the preview box (Triggers on text input change)
    $('body').on('input', 'input[name="properties[2. Add text]"], input[name="properties[Add text]"]', function() {
        var newText = $(this).val().trim();
        $('#displayTextBold').text(newText);
    });

    // 2. Function to add CSS classes to the font option titles
    function applyFontClasses() {
        $('.bold_option.bold_option_swatch .bold_option_value_title').each(function() {
            var titleText = $(this).text().trim();
            
            // Add classes only if they don't already exist (prevents duplication)
            if (titleText.includes('Font Futura PT Light') && !$(this).hasClass('futuramediumbt')) {
                $(this).addClass('futuramediumbt');
            }
            if (titleText.includes('Font Bangers') && !$(this).hasClass('BangersRegular')) {
                $(this).addClass('BangersRegular');
            }
            if (titleText.includes('Font Courgette') && !$(this).hasClass('Courgette')) {
                $(this).addClass('Courgette');
            }
            if (titleText.includes('Font Alex Brush') && !$(this).hasClass('AlexBrushRegular')) {
                $(this).addClass('AlexBrushRegular');
            }
            if (titleText.includes('Font Amatic SC') && !$(this).hasClass('AmaticSC-Regular')) {
                $(this).addClass('AmaticSC-Regular');
            }
            if (titleText.includes('Font Smooch') && !$(this).hasClass('Smooch')) {
                $(this).addClass('Smooch');
            }
        });
    }

    // 3. Font change listener (Now independent of the checkbox)
    $('body').on('change', '.bold_option.bold_option_swatch .bold_option_value input[type="checkbox"]', function() {
        // Ensure classes are applied before fetching them
        applyFontClasses(); 
        
        // Get the class from the selected font
        var newClass = $(this).closest('.bold_option_value').find('.bold_option_value_title').attr('class');
        
        // Remove old classes from the preview box and add the new one
        $('#displayTextBold').removeClass().addClass(newClass);
    });

    // 4. Bold app loads options dynamically, 
    // so we check every 200ms until options appear to apply the classes
    var fontCheckInterval = setInterval(function() {
        if ($('.bold_option.bold_option_swatch .bold_option_value_title').length > 0) {
            applyFontClasses();
            clearInterval(fontCheckInterval); // Stop checking once elements are found
        }
    }, 200);

});

// Logic to hide "Preview" and "Info:" titles remains the same
function hideBoldTitles() {
  const elements = document.querySelectorAll('.bold_option_title');
  let found = false;

  elements.forEach(el => {
    const text = el.textContent.trim();
    if (text === "Preview" || text === "Info:") {
      el.style.display = "none";
      found = true;
    }
  });

  return found;
}

const interval = setInterval(() => {
  if (hideBoldTitles()) {
    clearInterval(interval); 
  }
}, 100);